import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export function initSentry() {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    enabled: process.env.NODE_ENV === 'production',
    ignoreErrors: ['form error'],
    initialScope: {
      tags: {
        app: process.env.VUE_APP_TITLE,
      },
    },
  });
}
